import set from 'lodash/set';
import get from 'lodash/get'
function wait(ms, defaultValue) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms, defaultValue);
  });
}

export default (bridge) => {
  let _language;
  const fns = {
    sendCustomMessage(commandName, params, sendFailedCallback) {
      bridge.sendCustomMessage(commandName, params, sendFailedCallback);
    },
    sendErrorMessage(params, sendFailedCallback) {
      bridge.sendErrorMessage(params, sendFailedCallback);
    },
    sendCloseMessage(params, sendFailedCallback) {
      bridge.sendCloseMessage(params, sendFailedCallback);
    },
    exposeFunction(path, functionBody) {
      set(window, path, wrapperFunction.bind(this));
      // alert('pathpathpath---', path)
      //console.log(`pathpathpath---`, path);
      function wrapperFunction(/*arguments from native call*/) {
        const args = arguments;
        process.nextTick(() => {
          functionBody(...args);
        });
      }
    }
  };

  fns.exposeFunction('setLanguage', (data) => {
    _language = get(data, 'language');
  });

  return {
    ...fns,
    async getLanguage() {
      // make sure the bridge is valid before calling this funtion
      const getFallbackLang = () => {
        console.log(`getFallbackLang`);
        if (window.navigator.userAgent.includes("DisneyRALanguage")) {
          console.log(_language ? _language : (/DisneyRALanguage\/en/i.test(window.navigator.userAgent) ? 'en' : 'zh'))
          return (_language ? _language : (/DisneyRALanguage\/en/i.test(window.navigator.userAgent) ? 'en' : 'zh'));
        }
        return (_language ? _language : (/zh/i.test(window.navigator.language) ? 'zh' : 'en'));
      };
      if (bridge) {
        if (_language) {
          return Promise.resolve(_language);
        }
        const fnPromise = new Promise((resolve) => {
          fns.exposeFunction('getLanguage', (data) => {
            _language = get(data, 'language');
            resolve(_language);
          });

          fns.sendCustomMessage('getLanguage', {}, () => {
            const _fallback = getFallbackLang();
            console.log(`bridge failed getLanguage use fallback lang: ${_fallback}`);
            resolve(_fallback);
          });
        });
        return Promise.race([fnPromise, wait(300, getFallbackLang())]);
      } else {
        const _fallback = getFallbackLang();
        console.log(`bridge not init, getLanguage use browser lang: ${_fallback}`);
        return Promise.resolve(_fallback);
      }
    },
    showBanner(title, message, bannerType = 0, callback) {
      if (bridge) {
        fns.sendCustomMessage('showBanner', {
          title, message, bannerType
        }, callback);
      } else {
        console.log(`bridge not init, showBanner: ${title}, ${message}`);
      }
    },
    goToNativeDeepLink(url, callback) {
      if (bridge) {
        /^((http|https|ftp):\/\/)/.test(url) ? (window.location.href = url) :
          fns.sendCustomMessage('route', { path: url }, callback);
      }
    },
    gotoCreateParty(callback) {
      console.log(`gotoCreateParty`);
      if (bridge) {
        fns.sendCustomMessage('gotoCreateParty', { test: '' }, callback);
      }
    },
    gotoPrizeRecord(callback) {
      console.log(`gotoPrizeRecord`);
      if (bridge) {
        fns.sendCustomMessage('gotoPrizeRecord', { test2: '' }, callback);
      }
    },
    gotoTC(callback) {
      console.log(`gotoTC`);
      if (bridge) {
        fns.sendCustomMessage('gotoTC', { test: '' }, callback);
      }
    },
    // Analytics
    trackAction(actionCode, contextData, callback) {
      try {
        if (!actionCode) {
          return;
        }
        if (bridge) {
          fns.sendCustomMessage('trackAction', {
            'action': actionCode,
            'context': contextData,
          }, callback);
        }
      } catch (e) {
        // e
      }
    },
    trackState(stateCode, contextData, callback) {
      console.log(`trackState: ${stateCode}, ${JSON.stringify(contextData)}`)
      try {
        if (!stateCode) {
          return;
        }
        if (bridge) {
          fns.sendCustomMessage('trackState', {
            'state': stateCode,
            'context': contextData,
          }, callback);
        }
      } catch (e) {
        // e
      }
    }
  };
};


